import { useEffect } from 'react';
import { useDiagramViewStore } from '../store/useDiagramViewStore';
import { useSchemaStore } from '../store/useSchemaStore';

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable;
}

export function useKeyboardShortcuts(onOpenCommandPalette: () => void) {
  useEffect(() => {
    function handler(e: KeyboardEvent) {
      const mod = e.metaKey || e.ctrlKey;
      const store = useSchemaStore.getState();

      if (mod && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        onOpenCommandPalette();
        return;
      }
      if (mod && e.key.toLowerCase() === 'p') {
        e.preventDefault();
        onOpenCommandPalette();
        return;
      }
      const readOnly = useDiagramViewStore.getState().readOnly;
      if (readOnly && (mod || e.key === 'Delete' || e.key === 'Backspace') && !(mod && e.key.toLowerCase() === 'k')) {
        if (mod && e.key.toLowerCase() === 's') e.preventDefault();
        return;
      }

      if (mod && e.key.toLowerCase() === 's') {
        e.preventDefault();
        store.save();
        return;
      }
      if (mod && !e.shiftKey && e.key.toLowerCase() === 'z') {
        e.preventDefault();
        store.undo();
        return;
      }
      if ((mod && e.shiftKey && e.key.toLowerCase() === 'z') || (mod && e.key.toLowerCase() === 'y')) {
        e.preventDefault();
        store.redo();
        return;
      }

      if (isTypingTarget(document.activeElement) || mod) return;

      if (e.key.toLowerCase() === 't') {
        e.preventDefault();
        store.addTable();
      } else if (e.key.toLowerCase() === 'g') {
        e.preventDefault();
        store.addGroup();
      } else if (e.key.toLowerCase() === 'f') {
        e.preventDefault();
        useDiagramViewStore.getState().instance?.fitView({ duration: 300 });
      } else if (e.key === 'Delete' || e.key === 'Backspace') {
        const multi = useDiagramViewStore.getState().multiSelectedIds.filter((id) => !id.startsWith('group:'));
        if (multi.length > 1) {
          e.preventDefault();
          store.deleteTables(multi);
          useDiagramViewStore.getState().setMultiSelectedIds([]);
          return;
        }
        const sel = store.selection;
        if (!sel) return;
        e.preventDefault();
        if (sel.type === 'table') store.deleteTable(sel.id);
        else if (sel.type === 'group') store.deleteGroup(sel.id);
        else if (sel.type === 'relationship') store.deleteRelationship(sel.id);
        else if (sel.type === 'enum') store.deleteEnum(sel.id);
      }
    }

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onOpenCommandPalette]);
}
